module.exports = __webpack_public_path__ + "img/packaged.eb342487.png";